import React, { useState } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';

/**
 * Password field with show/hide toggle — use everywhere instead of type="password".
 * Optional onRevealRequest: admin fields can load a saved secret when the box is empty.
 */
export default function PasswordInput({
  className = 'form-control',
  wrapClassName = '',
  allowToggleWhenDisabled = false,
  disabled = false,
  onRevealRequest,
  value,
  onChange,
  ...inputProps
}) {
  const [visible, setVisible] = useState(false);
  const [revealBusy, setRevealBusy] = useState(false);
  const isSm = String(className).includes('form-control-sm');
  const toggleDisabled = (disabled && !allowToggleWhenDisabled) || revealBusy;
  const hasValue = Boolean(String(value ?? '').trim());

  const handleToggle = async () => {
    if (toggleDisabled) return;

    if (!visible) {
      if (!hasValue && typeof onRevealRequest === 'function') {
        setRevealBusy(true);
        try {
          const loaded = await onRevealRequest();
          if (loaded) {
            setVisible(true);
            return;
          }
        } finally {
          setRevealBusy(false);
        }
      }
      setVisible(true);
      return;
    }

    setVisible(false);
  };

  return (
    <div
      className={`password-input-wrap${isSm ? ' password-input-wrap--sm' : ''}${visible ? ' password-input-wrap--visible' : ''}${wrapClassName ? ` ${wrapClassName}` : ''}`}
    >
      <input
        {...inputProps}
        value={value}
        onChange={onChange}
        disabled={disabled}
        type={visible ? 'text' : 'password'}
        className={className}
        autoComplete={inputProps.autoComplete || 'off'}
      />
      <button
        type="button"
        className="password-input-toggle"
        onMouseDown={(e) => e.preventDefault()}
        onClick={handleToggle}
        aria-label={visible ? 'Hide password' : 'Show password'}
        aria-pressed={visible}
        aria-busy={revealBusy}
        disabled={toggleDisabled}
        tabIndex={toggleDisabled ? -1 : 0}
      >
        {revealBusy ? (
          <span className="password-input-toggle__spinner" aria-hidden="true" />
        ) : visible ? (
          <FiEyeOff aria-hidden="true" />
        ) : (
          <FiEye aria-hidden="true" />
        )}
      </button>
    </div>
  );
}
